import { AxiosError, AxiosResponse } from 'axios';
import { Button } from 'components/universal/button';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { toast } from 'react-toastify';
import { acceptUserAxios } from 'services/registration';
import { APIErrors } from 'types/api';
import { employeesInterface } from 'views/employee-management';
import cls from './acceptUserFormModal.module.scss';

export interface DeleteUsersValue {
    id: number;
}

interface AcceptUserModalInterface {
    user: employeesInterface;
    onCancel: (boolean) => void;
    setShowFirstLogin: (boolean) => void;
}

export const AcceptUserModal = ({
    user,
    onCancel,
    setShowFirstLogin
}: AcceptUserModalInterface) => {
    const { t } = useTranslation();
    
    const {
        register,
        handleSubmit,
        setError,
        setValue,
        formState: { errors },
    } = useForm<DeleteUsersValue>({
        defaultValues: {
            id: 0,
        },
    });

    useEffect(() => {
        setValue('id', user.id);
    }, [user, setValue]);

    const onSubmit = (formObject: employeesInterface) => {
        acceptUserHandler.mutate(formObject.id);
    };

    const acceptUserHandler = useMutation<
        AxiosResponse<{ message: string }>,
        AxiosError<APIErrors>,
        number                              
    >((data) => acceptUserAxios(data), {
        onSuccess: (data) => {
            if (data.status === 200) {
                toast.success(t('employeeManagement.acceptSuccessMessage'));
                onCancel(true);
                setShowFirstLogin(true);
            }
        },
        onError: (error) => {
            toast.error(t('employeeManagement.acceptErrorMessage'));
            onCancel(true);
        },
    });

    return (
        <>
            <h3 className={cls.modalHeader}>{t('employeeManagement.firstLogin')}: {user.first_name} {user.last_name}</h3>
            <p className={cls.modalDescription}>{t('employeeManagement.firstLoginDescription')}</p>
            <form onSubmit={handleSubmit(onSubmit)} noValidate>
                <input {...register('id')} type="hidden" />
                <div className={cls.modalButtonWrapper}>
                    <Button className={cls.modalButton} styleType="border" type="button" onClick={onCancel}>
                        {t('employeeManagement.cancel')}
                    </Button>
                    <Button className={cls.modalButton} type="submit">
                        {t('employeeManagement.accept')}
                    </Button>
                </div>
            </form>
        </>
    );
};
